/**
 * Utility functions to map between backend and frontend formats
 * for want list default preferences.
 *
 * Backend uses:
 * - Conditions: 'NEAR_MINT', 'SLIGHTLY_PLAYED', 'MODERATELY_PLAYED', etc.
 * - Languages: lowercase codes ('en', 'es', 'fr', etc.)
 *
 * Frontend uses:
 * - Conditions: 'NM', 'LP', 'MP', etc.
 * - Languages: uppercase codes ('EN', 'ES', 'FR', etc.)
 */

/**
 * Maps backend condition format to frontend display format
 * @param conditions Array of backend condition strings
 * @returns Array of frontend condition codes
 */
export function mapBackendConditionsToFrontend(conditions?: string[]): string[] {
  if (!conditions || conditions.length === 0) {
    return [];
  }

  const map: { [key: string]: string } = {
    'NEAR_MINT': 'NM',
    'SLIGHTLY_PLAYED': 'LP',
    'MODERATELY_PLAYED': 'MP',
    'HEAVILY_PLAYED': 'HP',
    'DAMAGED': 'DMG'
  };

  return conditions.map(c => map[c] || c);
}

/**
 * Maps frontend condition codes to backend format
 * @param conditions Array of frontend condition codes
 * @returns Array of backend condition strings
 */
export function mapFrontendConditionsToBackend(conditions: string[]): string[] {
  const map: { [key: string]: string } = {
    'NM': 'NEAR_MINT',
    'LP': 'SLIGHTLY_PLAYED',
    'MP': 'MODERATELY_PLAYED',
    'HP': 'HEAVILY_PLAYED',
    'DMG': 'DAMAGED'
  };

  return conditions.map(c => map[c] || c);
}

